var ImageGalleryDataVariationA = {
  appliedClass: 'gallery-media',
  imgSrc: 'https://images.ctfassets.net/rt5zmd3ipxai/49pevtaQkgQMcUyCiEkwge/33c9591cba03f130316d3fe61e608ac5/Image.png',
  modalUrl: 'https://images.ctfassets.net/rt5zmd3ipxai/49pevtaQkgQMcUyCiEkwge/33c9591cba03f130316d3fe61e608ac5/Image.png',
  title: 'Tile- Product-Image',
  tileData: {
    title: 'Image Text Card Title',
    imgSrc: 'https://images.ctfassets.net/rt5zmd3ipxai/49pevtaQkgQMcUyCiEkwge/33c9591cba03f130316d3fe61e608ac5/Image.png',
    altText: '',
    mediaType: 'ContentfulImage',
    appliedClass: ''
  }
};
var ImageGalleryDataVariationB = {
  appliedClass: 'gallery-media',
  imgSrc: 'https://images.ctfassets.net/rt5zmd3ipxai/49pevtaQkgQMcUyCiEkwge/33c9591cba03f130316d3fe61e608ac5/Image.png',
  modalUrl: 'https://images.ctfassets.net/rt5zmd3ipxai/49pevtaQkgQMcUyCiEkwge/33c9591cba03f130316d3fe61e608ac5/Image.png',
  title: 'Tile- Product-Image',
  tileData: {
    title: 'Image Text Card Title',
    imgSrc: 'https://images.ctfassets.net/rt5zmd3ipxai/49pevtaQkgQMcUyCiEkwge/33c9591cba03f130316d3fe61e608ac5/Image.png?fit=fill&fm=webp&h=400&w=300',
    altText: '',
    mediaType: 'ContentfulImage',
    appliedClass: 'gallery-media'
  }
};
export { ImageGalleryDataVariationA, ImageGalleryDataVariationB };